
import { MoreHorizontal, Plus } from 'lucide-react';

export interface SavedView {
  id: string;
  name: string;
}

interface SavedViewsListProps {
  title?: string;
  views: SavedView[];
  activeViewId?: string;
  onSelect: (id: string) => void;
  onAddView?: () => void;
}

export function SavedViewsList({ title = "Vues enregistrées", views, activeViewId, onSelect, onAddView }: SavedViewsListProps) {
  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between mb-2 px-2 text-xs font-semibold text-slate-500 uppercase tracking-wider">
        {title}
        {onAddView && (
          <button
            onClick={onAddView}
            className="p-1 text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-200 rounded-sm hover:bg-slate-200 dark:hover:bg-slate-700"
            title="Nouvelle vue"
          >
            <Plus size={14} />
          </button>
        )}
      </div>
      <ul className="space-y-0.5">
        {views.map((view) => {
          const isActive = view.id === activeViewId;
          return (
            <li key={view.id} className="group relative">
              <button
                onClick={() => onSelect(view.id)}
                className={`w-full text-left flex items-center justify-between px-3 py-1.5 rounded-md text-sm transition-colors ${
                  isActive
                    ? 'bg-primary-50 dark:bg-primary-900/30 text-primary-700 dark:text-primary-400 font-medium'
                    : 'text-slate-600 dark:text-slate-300 hover:bg-slate-200/50 dark:hover:bg-slate-700/50'
                }`}
              >
                <span className="truncate pr-4">{view.name}</span>
              </button>

              {/* Kebab action available on hover */}
              <button className="absolute right-1 top-1 p-1 opacity-0 group-hover:opacity-100 text-slate-500 dark:text-slate-400 hover:text-slate-800 rounded-sm bg-white dark:bg-slate-800 shadow-sm border border-slate-100 dark:border-slate-700">
                <MoreHorizontal size={14} />
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
